export default __webpack_public_path__ + "static/media/change_calendar.cf9ab791.svg";